/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_DocumentationInputs */

const en_listing_documentation = /** @type {(inputs: Listing_DocumentationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing Documentation`)
};

const id_listing_documentation = /** @type {(inputs: Listing_DocumentationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumentasi Listing`)
};

/** @type {(inputs: Listing_DocumentationInputs) => LocalizedString} */
const es_listing_documentation = en_listing_documentation;

/** @type {(inputs: Listing_DocumentationInputs) => LocalizedString} */
const fr_listing_documentation = en_listing_documentation;

/** @type {(inputs: Listing_DocumentationInputs) => LocalizedString} */
const de_listing_documentation = en_listing_documentation;

/** @type {(inputs: Listing_DocumentationInputs) => LocalizedString} */
const ja_listing_documentation = en_listing_documentation;

/** @type {(inputs: Listing_DocumentationInputs) => LocalizedString} */
const zh_listing_documentation = en_listing_documentation;

/** @type {(inputs: Listing_DocumentationInputs) => LocalizedString} */
const ar_listing_documentation = en_listing_documentation;

/** @type {(inputs: Listing_DocumentationInputs) => LocalizedString} */
const it_listing_documentation = en_listing_documentation;

/** @type {(inputs: Listing_DocumentationInputs) => LocalizedString} */
const ru_listing_documentation = en_listing_documentation;

/** @type {(inputs: Listing_DocumentationInputs) => LocalizedString} */
const pt_listing_documentation = en_listing_documentation;

/** @type {(inputs: Listing_DocumentationInputs) => LocalizedString} */
const ko_listing_documentation = en_listing_documentation;

/**
* | output |
* | --- |
* | "Listing Documentation" |
*
* @param {Listing_DocumentationInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_documentation = /** @type {((inputs?: Listing_DocumentationInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_DocumentationInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_documentation(inputs)
	if (locale === "es") return es_listing_documentation(inputs)
	if (locale === "fr") return fr_listing_documentation(inputs)
	if (locale === "de") return de_listing_documentation(inputs)
	if (locale === "ja") return ja_listing_documentation(inputs)
	if (locale === "zh") return zh_listing_documentation(inputs)
	if (locale === "ar") return ar_listing_documentation(inputs)
	if (locale === "id") return id_listing_documentation(inputs)
	if (locale === "it") return it_listing_documentation(inputs)
	if (locale === "ru") return ru_listing_documentation(inputs)
	if (locale === "pt") return pt_listing_documentation(inputs)
	return ko_listing_documentation(inputs)
});